import React, { useContext } from 'react'
import { Spacer, TabMenu, TabMenuButton, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const SessionLayout1 = ({ baseUrl, children }) => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   const buttons = [{
      name: 'Overview',
      to: baseUrl,
      exact: true
   }].concat(initiative.customPages.map(page => ({
      name: page.title,
      to: `${baseUrl}/pages/${page.slug}`
   })))

   if (initiative.appsFilesEnabled) {
      buttons.push({
         name: 'Files',
         to: `${baseUrl}/files`
      })
   }

   return (
      <View padding="24px[a] 30px[b] 60px[c] 48px[d-f]">
         <View width="100%">
            <View width="100%">
               <Text
                  color="#000"
                  size="0.9"
                  weight="medium"
                  transform="uppercase">
                  {initiative.type.nameSingular}
               </Text>
            </View>
            <Spacer size="2" />
            <Text
               color="#000"
               size="8[a-b] 9[c] 9[d] 10[e] 10[f]"
               letterSpacing="-0.5px"
               weight="medium">
               {initiative.name}
            </Text>
            {initiative.subtitle && (
               <>
                  <View width="100%" height="18px[a-b] 24px[c-f]" />
                  <View
                     float="left"
                     width="30px"
                     height="3px"
                     backgroundColor="#aaa"
                  />
                  <View
                     width="100%"
                     marginTop="18px[a-b] 24px[c-f]">
                     <Text
                        size="3[a-b] 4[c] 3[d] 4[e-f]"
                        lineHeight="130%"
                        color="#888">
                        {initiative.subtitle}
                     </Text>
                  </View>
               </>
            )}
            <Spacer size="2" />
         </View>
         <View float="left" width="100%" borderBottom="1px solid #eee">
            <TabMenu
               buttonPaddingHorizontal="0px"
               buttonSpacing="24px"
               buttonSize="lg">
               {buttons.map(button => (
                  <TabMenuButton
                     key={button.to}
                     name={button.name}
                     linkTo={button.to}
                     linkExact={button.exact}
                  />
               ))}
            </TabMenu>
         </View>
         {children}
         <Spacer size="6" />
      </View>
   )
}

SessionLayout1.propTypes = {
   baseUrl: PropTypes.string.isRequired,
   children: PropTypes.node.isRequired
}

export default SessionLayout1
